export const environment = {  production:true,  envName: 'PROD', appInsightsKey: '3ae2c966-e40f-4882-bf88-0199249e8e75',  ccaName: 'PCE',  defaultURL: 'https://optpce.communityenergysolutions.com/api'};
